module.exports = __webpack_public_path__ + "static/media/delete-checklist.a9682168.svg";